export default {
  text: 'black',
  primary: '#122340',
  secondary: '#0d1d34',
  background: 'white',
  backgroundSecondary: 'grey',
  light: '#FFF',
  dark: '#202020'
}
